var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SearchHeader",on:{"click":function($event){_vm.broadcast('close-menus')}}},[(_vm.SearchHeaderText || _vm.text)?_c('h1',[_vm._v(_vm._s(_vm.text || _vm.SearchHeaderText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }